import { render } from "./panel-month-range.vue?vue&type=template&id=72157db3&ts=true"
import script from "./panel-month-range.vue?vue&type=script&lang=ts"
export * from "./panel-month-range.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__